const detectCurrentLabel = (hostname?: string): string => {
  const blacklist = ['localhost', 'www', 'site', 'proxy'];

  hostname = (hostname || window.location.hostname).toLowerCase();
  if (hostname.startsWith('www.')) {
    hostname = hostname.slice(4);
  }

  if (hostname.endsWith('.localhost')) {
    hostname = hostname.slice(0, -'.localhost'.length);
  }

  const domainMap = new Map<string, string>([
    ['magaluconecta.com.br', 'magalu'],
    ['vidasaudavel-tokiomarine.com.br', 'tokiomarine'],
    ['vidasaudavel-tokiomarine.cdfhml.net', 'tokiomarine'],
    ['coachsaude.cdf.net', 'ticket'],
    ['coachsaude.cdfhml.net', 'ticket'],
    ['pernambucanas-cdfdigital.cdfhml.net', 'pernambucanas'],
    ['localhost:3000', 'pernambucanas'],
  ]);

  if (domainMap.has(hostname)) {
    return domainMap.get(hostname)!;
  }

  const alias = hostname.split('.')[0];
  if (!alias.match(/^[a-z]/) || blacklist.includes(alias)) {
    return 'cdf'; // FIXME extra pernambucanas magalu pontofrio casasbahia
  }

  return alias;
};

export default detectCurrentLabel;